import { render, staticRenderFns } from "./ChapterItems.vue?vue&type=template&id=e3ea9abc"
import script from "./ChapterItems.vue?vue&type=script&lang=js"
export * from "./ChapterItems.vue?vue&type=script&lang=js"
import style0 from "./ChapterItems.vue?vue&type=style&index=0&id=e3ea9abc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports